/***********************************************
  IceMedX - Developed By IceMedx Corporation
  Copyright 2022 IceMedx Corporation
***********************************************/
import { Injectable } from '@angular/core';
import { IceTypes } from '../icetypes';
import { payment } from './payment';

export class payto extends payment {
  pay_to_key: string = "";
  pay_to_name: string = "";
  pay_from_name: string = "";
  from_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  from_trans_account: string = "";
  pay_status: IceTypes.trans_status = IceTypes.trans_status.isNone;

  constructor() {
    super();
  }

  gettablename(): string {
    return "PAY_TO";
  }
}
